import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPasswordRecoveryNewPasswordSet = loadable(
  () => import('./PasswordRecoveryNewPasswordSet'),
  {
    fallback: <Loader />,
  },
);
